import { constants } from '../config';

/* **** showLoading *** */
export const showLoading = (show) => ({
  type: constants.SHOW_LOADING,
  show,
});
